'use strict';

import React from 'react';
import flux from 'utils/flux';

var QuotaWarning = React.createClass({
    displayName: 'QuotaWarning',
    render() {
        const { quotaExceeded } = flux.getStore('media').getState();

        if ( !quotaExceeded ) {
            return false;
        }

        return (
            <div className="quota-warning">
                <i className="gopro-info-sign-alt"></i>
                {' '}
                {flux.t('exceeded_quota_warning')}
            </div>
        );
    }
});

module.exports = QuotaWarning;



// WEBPACK FOOTER //
// ./app/components/quota/quotaWarning.jsx